import React from "react";
import { Input, PropertyFilterProps } from "@cloudscape-design/components";
import { IFlightPlan } from "../../data/interfaces/ICampaign";
import { formatDate } from "../../data/helpers/dates";

export const COLUMN_ID = {
  FLIGHT_PLAN_ID: "id",
  FLIGHT_PLAN_NAME: "name",
  ASSOCIATED_TACSID: "tacsId",
  START_DATE: "startDate",
  END_DATE: "endDate",
  NOTES: "flightplannotes"
};

export const RAW_COLUMNS = [
  {
    id: COLUMN_ID.FLIGHT_PLAN_ID,
    header: "Flight plan ID",
    cell: (e: IFlightPlan) => e.id,
    sortingField: COLUMN_ID.FLIGHT_PLAN_ID,
    minWidth: "130px",
  },
  {
    id: COLUMN_ID.FLIGHT_PLAN_NAME,
    header: "Flight plan name",
    cell: (e: IFlightPlan) => e.name,
    sortingField: COLUMN_ID.FLIGHT_PLAN_NAME,
    editConfig: {
      editingCell: (
        e:any,
        {
          currentValue,
          setValue,
        }: { currentValue: string; setValue: (value: string) => void }
      ) => {
        return (
          <Input
            autoFocus={true}
            value={currentValue ?? e.name}
            onChange={(event) => setValue(event.detail.value)}
          />
        );
      },
    },
    width: "240px",
    maxWidth: "500px"
  },
  {
    id: COLUMN_ID.ASSOCIATED_TACSID,
    header: "Associated TaCS ID",
    cell: (e: IFlightPlan) => e.tacsId,
    sortingField: COLUMN_ID.ASSOCIATED_TACSID,
  },
  {
    id: COLUMN_ID.START_DATE,
    header: "Start date",
    cell: (e: IFlightPlan) => formatDate(e.startDate),
    sortingField: COLUMN_ID.START_DATE,
    minWidth: "130px",
  },
  {
    id: COLUMN_ID.END_DATE,
    header: "End date",
    cell: (e: IFlightPlan) => formatDate(e.endDate),
    sortingField: COLUMN_ID.END_DATE,
    minWidth: "130px",
  },
  {
    id: COLUMN_ID.NOTES,
    header: "Notes",
    cell: (e: IFlightPlan) => e.notes,
    minWidth: "130px",
    maxWidth:"420px"
  },
];

export const TABLE_VISIBLE_COLUMNS = [
  COLUMN_ID.FLIGHT_PLAN_ID,
  COLUMN_ID.FLIGHT_PLAN_NAME,
  COLUMN_ID.ASSOCIATED_TACSID,
  COLUMN_ID.START_DATE,
  COLUMN_ID.END_DATE,
  COLUMN_ID.NOTES
];

export const PREFERENCES_VISIBLE_COLUMNS = [
  COLUMN_ID.FLIGHT_PLAN_NAME,
  COLUMN_ID.ASSOCIATED_TACSID,
  COLUMN_ID.START_DATE,
  COLUMN_ID.END_DATE,
];

export const PREFERENCES_VISIBLE_CONTENT = [
  {
    id: COLUMN_ID.FLIGHT_PLAN_ID,
    label: "Flight plan ID",
  },
  {
    id: COLUMN_ID.FLIGHT_PLAN_NAME,
    label: "Flight plan name",
  },
  {
    id: COLUMN_ID.ASSOCIATED_TACSID,
    label: "Associated TaCS ID",
  },
  {
    id: COLUMN_ID.START_DATE,
    label: "Start date",
  },
  {
    id: COLUMN_ID.END_DATE,
    label: "End date",
  },
  {
    id: COLUMN_ID.NOTES,
    label: "Notes",
  },
];

export const FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
  {
    key: "tacsId",
    operators: ["="],
    propertyLabel: "Associated TaCS ID",
    groupValuesLabel: "Associated TaCS ID values",
  },
];
